<div class="modal-header bg-light">

   <h4> Consultation PDC</h4>

</div>

<div class="container-fluid mt-3">
  <div class="card border-primary-subtle shadow-sm mb-4">
    <div class="card-body bg-soft-primary">
      <div class="row align-items-center">
        <div class="col-md-8">
          <label class="fw-bold mb-1">Sélectionner le Plan de Développement Communal (PDC)</label>
          <div class="input-group">
            <span class="input-group-text bg-white"><i class="mdi mdi-filter-variant"></i></span>
            <select
              name="selectedPdc"
              class="form-select form-select-lg"
              [(ngModel)]="selectedPdc"
              (change)="getDetailPdcActions()">
              <option [ngValue]="undefined" disabled selected>Veuillez choisir un PDC dans la liste...</option>
              <option *ngFor="let item of pdcData" [ngValue]="item">
                {{ item?.annee_debut }} - {{ item?.annee_fin }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4 text-md-end mt-3 mt-md-0" *ngIf="selectedPdc">
           <span class="badge bg-success p-2">PDC Sélectionné</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!selectedPdc" class="text-center py-5 my-5">
    <div class="avatar-lg mx-auto mb-4">
      <div class="avatar-title bg-soft-warning rounded-circle">
        <i class="mdi mdi-alert-circle-outline display-4 text-warning"></i>
      </div>
    </div>
    <h4 class="text-muted">Aucun PDC sélectionné</h4>
    <p class="text-muted">Veuillez sélectionner un PDC dans la liste ci-dessus pour consulter les détails des actions.</p>
  </div>

  <div *ngIf="selectedPdc" class="row">
    <div class="col-lg-12">
      <div class="card shadow-sm">
        <div class="card-body">
          
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0 text-dark fw-bold">Détails des Actions</h5>
            
            <div class="dataTables_filter">
              <div class="input-group input-group-sm">
                <!-- Bouton Exporter -->
                            <div class="dropdown" ngbDropdown>
                                <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle"
                                    id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false">
                                    Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu
                                    aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="exportToDocument('pdf')">Au format PDF</a>
                                    <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="exportToDocument('excel')">Au format Excel</a>
                                </div>
                            </div>
                <!-- <input type="text" name="searchTerm" [(ngModel)]="searchTerm" (keyup)="filterProjet()"
                  class="form-control" placeholder="Rechercher une action...">
                <span class="input-group-text"><i class="mdi mdi-magnify"></i></span> -->
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-centered table-hover dt-responsive nowrap w-100">
              <thead class="bg-light-custom">
                <tr>
                  <th class="text-center">#</th>
                  <th>Code</th>
                  <th>Libellé</th>
                  <th class="text-center">Poids (%)</th>
                  <th class="text-end">Coût Total</th>
                  <th *ngFor="let fin of listeAnnee" class="text-end text-primary">
                    {{ fin?.annee }}
                  </th>
                </tr>
              </thead>

                  <tbody *ngIf="!isLoading && paginatedProjets.length > 0">
        <ng-container *ngFor="let item of paginatedProjets; let i = index">
          
          <tr class="bg-light-custom">
            <td class="text-center text-muted fw-bold">{{ i + firstProjets + 1 }}</td>
            <td class="fw-bold text-primary">{{ item?.action.code }}</td>
            <td class="text-wrap fw-bold" style="min-width: 250px;">{{ item?.action.libelle }}</td>
            <td class="text-center">
              <span class="badge bg-info text-dark">{{ item?.poids }}%</span>
            </td>
            <td class="text-end fw-bold">{{ item?.mt_total | formatMoney:null }}</td>
            <td *ngFor="let fin of item?.details_pdc_financements_actions" class="text-end fw-bold">
              {{ fin?.montant | formatMoney:null }}
            </td>
          </tr>

          <tr *ngFor="let act of getListActivitiesByPdcActionId(item.id)" class="table-sm">
            <td class="text-center">
              <i class="mdi mdi-arrow-return-right text-muted"></i>
            </td>
            <td class="text-muted ps-4 small">{{ act.code }}</td>
            <td class="text-muted small" colspan="1">{{ act.libelle }}</td>
            <td class="text-center small">{{ act.poids }}%</td>
            <td class="text-end small text-secondary italic">{{ act.mt_total | formatMoney:null }}</td>
               <td *ngFor="let finAct of act?.details_pdc_financements_activites" class="text-end fw-bold">
              {{ finAct?.montant | formatMoney:null }}
            </td>
          </tr>
          
        </ng-container>
      </tbody>


            </table>
          </div>

          <div *ngIf="isLoading" class="text-center py-4">
            <div class="spinner-chase mx-auto mb-3">
              <div class="chase-dot"></div><div class="chase-dot"></div><div class="chase-dot"></div>
            </div>
            <h6>Chargement des actions en cours...</h6>
          </div>

          <div *ngIf="!isLoading && paginatedProjets.length === 0" class="text-center py-4">
            <i class="mdi mdi-folder-open-outline display-4 text-muted"></i>
            <h5 class="text-muted mt-2">Aucune donnée trouvée pour ce PDC</h5>
          </div>

          <div class="mt-4 border-top pt-3">
            <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
              [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
            </p-paginator>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ngx-ui-loader></ngx-ui-loader>
<p-toast />